import { resourceReducer, getResources } from 'redux-resource';
import { httpStatusCodes, reset } from 'redux-resource-plugins';
import metaReducer from './metaReducer';

const users = resourceReducer('users', {
  plugins: [reset, metaReducer, httpStatusCodes],
});

export default users;

export const getAllUsers = (state, page = 1, childAccounts, userId) => {
  if (childAccounts) {
    return getResources(state, `pageChildAccounts${page}_${userId}`);
  } else {
    return getResources(state, `page${page}`);
  }
};
export const getAllUsersWithoutPagination = (state) => getResources(state);
export const getSearchUsers = (state, page = 1) =>
  getResources(state, `searchPage${page}`);
export const getUser = (state, userId) => getResources(state, [userId])[0];
export const getUserNotFound = (state, userId) =>
  state.meta[userId] && state.meta[userId].readStatusCode === 404;
export const getSaveUserStatus = (state, userId) =>
  state.meta[userId] && state.meta[userId].updateStatus;
export const getCreateUserStatus = (state) =>
  state.requests.create && state.requests.create.status;
export const getNewUserId = (state) =>
  state.requests.create &&
  state.requests.create.ids &&
  state.requests.create.ids[0];
export const getUserIsActiveErrorMessage = (state, userId) => {
  const requestKey = `toggleUserIsActive_${userId}`;
  const message =
    state.requests &&
    state.requests[requestKey] &&
    state.requests[requestKey].error;
  return message;
};
